import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";

const Map = () => {
  return (
    <MapContainer
      center={[35.328054, 33.606474]}
      zoom={5}
      scrollWheelZoom={false}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Marker position={[35.328054, 33.606474]}>
        <Popup>Tadaa ! Here's is Cyprus.</Popup>
      </Marker>
      <div className="map-content">
        <h3 className="switch__color">NATASHA</h3>
        <span>A.k.a Tascha</span>
        <br />
        <span>Location : Cyprus</span>
        <br />
        <span>
          <a
            href="mailto:chirombenatashatatenda@gmail.com"
            target="_blank"
            rel="noreferrer"
          >
            Email : chirombenatashatatenda@gmail.com
          </a>
        </span><br />
        <span>
          <a
            href="mailto:https://www.linkedin.com/in/natashatatendachirombe/"
            target="_blank"
            rel="noreferrer"
          >
            LinkedIn : Natasha (Tatenda) Chirombe
          </a>
        </span>        
      </div>
    </MapContainer>
  );
};

export default Map;
